(() => {
  const header = document.querySelector('[data-lbv-header]');
  const toggle = document.querySelector('[data-lbv-menu-toggle]');
  const mobileNav = document.querySelector('[data-lbv-mobile-nav]');
  if (!header || !toggle || !mobileNav) return;

  const setOpen = (open) => {
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Menu sluiten' : 'Menu openen');
    mobileNav.hidden = !open;
    header.classList.toggle('is-menu-open', open);
  };

  toggle.addEventListener('click', () => {
    setOpen(toggle.getAttribute('aria-expanded') !== 'true');
  });

  mobileNav.addEventListener('click', (event) => {
    if (event.target.closest('a')) setOpen(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setOpen(false);
  });

  window.addEventListener('resize', () => {
    if (window.innerWidth > 900) setOpen(false);
  });
})();